<template>
  <div>
    <SeoHead :title="page.title" :description="metaDescription" />

    <div class="landing-page-view min-h-screen bg-white" :style="pageThemeStyle">
      <div
        v-for="(section, index) in page.sections"
        :key="section.id || index"
        class="section-wrapper"
        :class="{ 'first-section': index === 0 }"
      >
        <component
          :is="getSectionComponent(section.type)"
          :section="section"
        />
      </div>

      <div v-if="!page.sections || page.sections.length === 0" class="flex items-center justify-center min-h-screen px-4 sm:px-6">
        <div class="text-center max-w-2xl mx-auto">
          <div class="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8 bg-gray-100 rounded-full flex items-center justify-center">
            <icon name="page" class="w-12 h-12 sm:w-16 sm:h-16 text-gray-400" />
          </div>
          <h1 class="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">{{ page.title || 'Landing Page' }}</h1>
          <p class="text-base sm:text-lg text-gray-600 mb-2">This page is under construction.</p>
          <p class="text-sm sm:text-base text-gray-500">Content will be available soon.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroSection from './Sections/HeroSection.vue'
import FeaturesSection from './Sections/FeaturesSection.vue'
import CtaSection from './Sections/CtaSection.vue'
import FaqSection from './Sections/FaqSection.vue'
import TestimonialsSection from './Sections/TestimonialsSection.vue'
import Icon from '@/Shared/Icon.vue'
import SeoHead from '@/Shared/SeoHead.vue'
import { getSectionComponentName, DEFAULT_PAGE_SETTINGS } from './sectionRegistry.js'

export default {
  components: {
    HeroSection,
    FeaturesSection,
    CtaSection,
    FaqSection,
    TestimonialsSection,
    Icon,
    SeoHead,
  },
  props: {
    page: { type: Object, required: true },
    title: { type: String, default: 'Landing Page' },
  },
  computed: {
    pageThemeStyle() {
      const settings = this.page.settings || DEFAULT_PAGE_SETTINGS
      return {
        '--lp-primary-color': settings.primary_color || DEFAULT_PAGE_SETTINGS.primary_color,
        fontFamily: settings.font_family || DEFAULT_PAGE_SETTINGS.font_family,
      }
    },
    metaDescription() {
      return this.page.settings?.meta_description || ''
    },
  },
  methods: {
    getSectionComponent(type) {
      return getSectionComponentName(type)
    },
  },
}
</script>

<style scoped>
.landing-page-view {
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

.section-wrapper {
  position: relative;
}
</style>
